import Vue from 'vue'

function parseLocalDate (value) {
  if (!value) return new Date(NaN)
  const date = new Date(value)
  if (isNaN(date)) return date
  const berlinStr = date.toLocaleDateString('en-CA', { timeZone: 'Europe/Berlin' })
  const [year, month, day] = berlinStr.split('-')
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
}

export default {
  parseLocalDate,
  filters: {
    dateFormat (value, vm) {
      let date = parseLocalDate(value)
      let options = {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }
      return date.toLocaleDateString(Vue.config.lang === 'en' ? 'en-UK' : Vue.config.lang, options)
    },
    currencyFormat (value, currency) {
      let formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currency
      })
      return formatter.format(value)
    }
  },
  create () {
    Object.keys(this.filters).forEach(function (filter, k) {
      Vue.filter(filter, this.filters[filter])
    }.bind(this))
  }
}
